import React from 'react';
import { Route, Routes } from 'react-router-dom';

import AppProvider from '@components/AppProvider';
import AppLayout from '@components/AppLayout';
import AuthLayout from '@components/AuthLayout';
import AdminLayout from '@components/AdminLayout';
import { SidebarProvider } from '@contexts/SidebarContext';

import PenaltiesAnalytics from '@modules/PenaltiesAnalytics';
import HomePage from '@modules/HomePage';
// import LoginPage from '@modules/LoginPage';
import LoginWithGooglePage from '@modules/LoginWithGooglePage';
import AuthCallback from '@modules/AuthCallback';
import NotFoundPage from '@modules/NotFoundPage';

import '@styles/global.scss';
import '@styles/ant.less';
import AnalyticsLayout from '@components/AnalyticsLayout';
import FinancialPage from '@modules/FinancialPage';
import TeamPage from '@modules/TeamPage';
import CarriersPage from '@modules/CarrierPage';
import CarrierLogsPage from '@modules/CarrierLogsPage';

function App() {
  return (
    <AppProvider>
      <SidebarProvider>
        <Routes>
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route
            path="/auth"
            element={
              <AppLayout>
                <AuthLayout />
              </AppLayout>
            }
          >
            <Route path="login" element={<LoginWithGooglePage />} />
          </Route>

          <Route
            path="/"
            element={
              <AppLayout>
                <AdminLayout />
              </AppLayout>
            }
          >
            <Route index element={<HomePage />} />
            <Route path="team" element={<TeamPage />} />
            <Route path="carriers" element={<CarriersPage />} />
            <Route path="carrier-logs" element={<CarrierLogsPage />} />
          </Route>

          <Route
            path="/financial"
            element={
              <AppLayout>
                <FinancialPage />
              </AppLayout>
            }
          />

          <Route
            path="/analytics"
            element={
              <AppLayout>
                <AnalyticsLayout />
              </AppLayout>
            }
          >
            <Route index element={<PenaltiesAnalytics />} />
          </Route>

          <Route
            path="*"
            element={
              <AppLayout>
                <NotFoundPage />
              </AppLayout>
            }
          />
        </Routes>
      </SidebarProvider>
    </AppProvider>
  );
}

export default App;
